module.exports = __webpack_public_path__ + "img/home_help.f5609a9.0025ae9b.svg";